import { Head, usePage } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { Breadcrumbs } from "@/components/ui/breadcrumb"
import { ConditionForm, type ConditionCategoryOption, type ConditionData } from "./ConditionForm"
import type { LibraryPhoto } from "@/components/pages-cms/types"
import type { PageProps } from "@/types/inertia"

type Props = PageProps & {
  next_position: number
  categories: ConditionCategoryOption[]
  photo_library: LibraryPhoto[]
}

export default function ConditionsNew() {
  const { props } = usePage<Props>()

  const empty: ConditionData = {
    slug: "",
    slug_es: "",
    parent_slug: null,
    kind: "page",
    link_path: null,
    condition_category_id: null,
    label: "",
    nav_label_en: "",
    nav_label_es: "",
    blurb_en: "",
    blurb_es: "",
    meta_title: "",
    meta_description: "",
    status: "draft",
    position: props.next_position,
  }

  return (
    <AdminShell>
      <Head title="New Condition Page">
        <meta name="description" content="Add a condition to Gisela's menu — a full landing page, a listed-only entry, or a link." />
        <meta property="og:title" content="New Condition Page" />
        <meta property="og:description" content="Add a condition to Gisela's menu — a full landing page, a listed-only entry, or a link." />
      </Head>

      <Breadcrumbs
        items={[
          { label: "Website Pages", href: "/admin/website" },
          { label: "Gisela Ramirez", href: "/admin/website?brand=gisela" },
          { label: "New condition page" },
        ]}
      />

      <PageHeader
        title="New condition page"
        description="Something else Gisela works with. A full page starts as a draft — you'll write (or AI-draft) its sections next, then publish it."
      />
      <div className="mt-8 max-w-2xl">
        <ConditionForm
          condition={empty}
          categories={props.categories}
          actionUrl="/admin/website/conditions"
          method="post"
          photoLibrary={props.photo_library}
        />
      </div>
    </AdminShell>
  )
}
